<template lang="html">
<div class="section">
  <div class="container">
    <h1 class="title">{{ msg }}</h1>
    <b-field>
      <b-button v-on:click="listUsers()">list all users</b-button>
    </b-field>
    <b-field>
      <b-button v-on:click="postTrace()">post test trace</b-button>
    </b-field>
    <ul>
      <li v-for="user in users" :key="user.url">
        {{ user.short_name }}
      </li>
    </ul>
  </div>
  <Websocket
    v-bind:wsConsumer="wsConsumer"
    v-bind:wsDebug="wsDebug">
  </Websocket>
</div>
</template>

<script>
import axios from 'axios'
import Websocket from './Websocket'

export default {
  components: {
    Websocket
  },
  props: {
    msg: String
  },
  data () {
    return {
      users: '',
      wsConsumer: 'echoauth',
      wsDebug: true
    }
  },
  methods: {
    listUsers () {
      axios({
        method: 'get',
        url: '/api/users'
      })
        .then((response) => {
          console.log(response)
          this.users = response.data.results
        })
        .catch((error) => {
          console.log(error)
        })
    },
    postTrace () {
      axios({
        method: 'post',
        url: '/api/traces',
        data: {
          // owner added by backend
          created: new Date().toISOString(),
          description: 'foo',
          data: ''
        }
      })
        .then((response) => {
          console.log(response)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    test () {
      axios({
        method: 'get',
        url: '/api/test'
      })
        .then(response => {
          console.log('test promise resolve', response)
          this.users = response.data
        })
        .catch(function (error) {
          console.log('test promise reject', error)
        })
    }
  },
  mounted () {
  }
}
</script>
